export default __webpack_public_path__ + "static/rovo-elevation-dark-367001de45e6b600e66696826c57238637970b18cc3f23a34f8023c60cfd6b82.png";